module.exports = __webpack_public_path__ + "static/customerbg2-1c3c244fd61696dea4e17c922bf19c94.jpg";